import React from 'react';
import { FileCard } from '../file-card';
import { StyledFileListItem } from './styled';
export const FileListItem = ({ file, maxSize, role = 'listitem', ...props }) => {
    const hasError = file.uploadStatus === 'error';
    return (React.createElement(StyledFileListItem, { key: file.uid, "$isError": hasError, role: role },
        React.createElement(FileCard, { file: file, hasError: hasError, maxSize: maxSize, ...props })));
};
